"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRequestData = getRequestData;
exports.setRequestData = setRequestData;
let requestData = {};
function getRequestData(key) {
    return key ? requestData[key] : requestData;
}
function setRequestData(key, value) {
    if (value && requestData) {
        requestData[key] = value;
    }
    else if (!value) {
        //single argument = overwrite the whole array
        requestData = key;
    }
}
//# sourceMappingURL=RequestData.js.map